import { render, staticRenderFns } from "./ImageViewer.vue?vue&type=template&id=5a70d0f4&"
import script from "./ImageViewer.vue?vue&type=script&lang=js&"
export * from "./ImageViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports